@if (isVisible()) {
  <app-alert-label class="alert-label" icon="Info" boxStyle="info">
    {{ "info_banner.message" | translate: interpolationParams() }}
  </app-alert-label>
}
